import { useQuery } from '@tanstack/react-query';
import { toast } from 'sonner';
import { userApi } from '../../services/userApi';

export const userKeys = {
  all: ['users'] as const,
  lists: () => [...userKeys.all, 'list'] as const,
  list: (filters?: { pageNumber?: number; pageSize?: number; search?: string }) =>
    [...userKeys.lists(), filters] as const,
  details: () => [...userKeys.all, 'detail'] as const,
  detail: (id: string) => [...userKeys.details(), id] as const,
};

export function useGetUser(id: string, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: userKeys.detail(id),
    queryFn: async () => {
      const response = await userApi.getById(id);
      if (!response.isSuccess) {
        toast.error(`Error: ${response.errorMessage || 'Failed to fetch user'}`);
      }
      return response;
    },
    enabled: options?.enabled ?? !!id,
  });
}

export function useGetUsers() {
  return useQuery({
    queryKey: userKeys.lists(),
    queryFn: async () => {
      const response = await userApi.getList();
      if (!response.isSuccess) {
        toast.error(`Error: ${response.errorMessage || 'Failed to fetch users'}`);
      }
      return response;
    },
  });
}

export function useGetUsersPaged(
  pageNumber: number = 1,
  pageSize: number = 10,
  search?: string
) {
  return useQuery({
    queryKey: userKeys.list({ pageNumber, pageSize, search }),
    queryFn: async () => {
      const response = await userApi.getPagedList(pageNumber, pageSize, search);
      if (!response.isSuccess) {
        toast.error(`Error: ${response.errorMessage || 'Failed to fetch users'}`);
      }
      return response;
    },
  });
}
